/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import {
  Select,
  MenuItem,
  Typography,
  Box,
  TextField,
  ListSubheader,
  InputAdornment,
  FormControl,
  Stack,
  Slider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import {
  FilterInfo,
  FilterSelected,
  ListItem as filterList,
} from "../../types/types";
import {
  FilterHandler,
  FiltersHandler,
  getExploreUrl,
} from "../../assets/library";
import { destinationList } from "../../assets/menu";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// export const StateFilter = (props:
//   | {
//       data: FilterInfo;
//       onSelection: any;
//       normalizeType: any;
//       appliedFilter: FilterSelected;
//       appliedFilters: FilterSelected[] | undefined;
//     }
//   | any) => {
//     console.log(props,"stateslist")
//   const navigate = useNavigate();
//   const destination: any = destinationList;
//   const stateList = (country: string) =>
//     Object.keys(destination[country] || {});
//   const countrieslist = props?.appliedFilters?.find(
//     (item: FilterSelected) => item.type === "country"
//   );
//   const statesByCountry =
//     countrieslist?.data?.flatMap((country: any) => stateList(country?.value)) ||
//     [];

//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedValue, setSelectedValue] = useState("");

//   const onSelection = (val: any) => {
//     const filterData = FilterHandler({
//       data: val,
//       filterInfo: props.data,
//       filter: props.appliedFilter,
//     });
//     const encodedUrl = location.search.slice(1); 
//     let decodedUrl = "";
//     try {
//       decodedUrl = window.atob(encodedUrl);
//     } catch (error) {
//       console.error("Error decoding URL", error);
//       decodedUrl = ""; 
//     }
  
//     const urlParams = new URLSearchParams(decodedUrl);
//     let FilterUrl = urlParams.get("FilterData");
//     const allFilters = FiltersHandler(
//       filterData,
//       FilterUrl ? JSON.parse(FilterUrl) : []
//     );
//     navigate(getExploreUrl("filterData", allFilters));
//     setSelectedValue(val.value);
//   };

//   const containsText = (text: string, searchText: string) =>
//   (text || "")?.toLowerCase()?.indexOf((searchText || "")?.toLowerCase()) > -1;

//   const displayedOptions = useMemo(
//     () =>
//       statesByCountry.filter((option: any) =>
//         containsText(option, searchQuery)
//       ),
//     [searchQuery, statesByCountry]
//   );

//   return (
//     <Box>
//       <FormControl fullWidth>
//         <Select
//           value={selectedValue}
//           onChange={(e) =>
//             onSelection({ name: e?.target?.value, value: e?.target?.value })
//           }
//           onClose={() => setSearchQuery("")}
//           renderValue={(selected: any) => {
//             if (selected.length === 0) {
//               return (
//                 <Typography sx={{ textTransform: "capitalize",color:"#3B3F76",fontSize:"14px" }}>
//                  State
//                 </Typography>
//               );
//             }
//             return selected;
//           }}
//           size="small"
//           fullWidth
//           displayEmpty
//           sx={{
//             "&.MuiInputBase-root": {
//               borderRadius: "10px !important",
//             },
//             "& .MuiOutlinedInput-notchedOutline": {
//               border: 0,
//             },
//             background: "#F0F1F9",
//             borderRadius: "10px",
//           }}
//           defaultValue=""
//           MenuProps={{
//             PaperProps: {
//               sx: {
//                 maxHeight: 300,
//                 maxWidth: 300,
//                 "&.MuiPaper-root": {
//                   boxShadow: 3,
//                   borderRadius: "15px !important",
//                 },
//               },
//             },
//             autoFocus: false,
//           }}
//           IconComponent={ExpandMoreIcon}
//         >
//          {displayedOptions?.length > 0 ?
//               <ListSubheader>
//                 <TextField
//                   size="small"
//                   autoFocus
//                   placeholder="Type to search..."
//                   fullWidth
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   onChange={(e) => setSearchQuery(e?.target?.value)}
//                   onKeyDown={(e) => {
//                     if (e.key !== "Escape") {
//                       e.stopPropagation();
//                     }
//                   }}
//                 />
//               </ListSubheader>:""}
//               {displayedOptions?.length > 0 ?
//                displayedOptions?.map((option: any, i: number) => (
//                 <MenuItem
//                   key={i}
//                   value={option}
//                   sx={{
//                     "& .MuiTypography-root": {
//                       fontSize: "14px !important",
//                     },
//                     "& .MuiSvgIcon-root ": {
//                       fontSize: "1rem",
//                     },
//                     whiteSpace: "normal",
//                     backgroundColor: props.appliedFilter?.data.find(
//                       (data: any) => data?.value === option
//                     )
//                       ? "grey"
//                       : "transparent",
//                   }}
//                 >
//                   {option}
//                 </MenuItem>
//               ))
//            : (
//             <MenuItem disabled>Please select country</MenuItem>
//           )}
//         </Select>
//       </FormControl>
//     </Box>
//   );
// };
export const StateFilter = (props: {
  data: FilterInfo;
  onSelection: any;
  normalizeType: any;
  appliedFilter: FilterSelected;
  appliedFilters: FilterSelected[] | undefined;
} | any) => {
  const navigate = useNavigate();
  const destination: any = destinationList;

  const stateList = (country: string) => {
    return destination[country] ? Object.keys(destination[country]) : [];
  };

  const countrieslist = props?.appliedFilters?.find(
    (item: FilterSelected) => item.type === "country"
  );

  const statesByCountry = countrieslist?.data?.flatMap((country: any) => {
    return country?.value ? stateList(country.value) : [];
  }) || [];

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  const onSelection = (val: any) => {
    const filterData = FilterHandler({
      data: val,
      filterInfo: props.data,
      filter: props.appliedFilter,
    });

    const encodedUrl = location.search.slice(1);
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = "";
    }

    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    const allFilters = FiltersHandler(
      filterData,
      FilterUrl ? JSON.parse(FilterUrl) : []
    );

    navigate(getExploreUrl("filterData", allFilters));
    setSelectedValue(val.value);
  };

  useEffect(() => {
    if (!countrieslist || statesByCountry.length === 0) {
      setSelectedValue("");
    }
  }, [countrieslist, statesByCountry]);

  const containsText = (text: string, searchText: string) =>
    (text || "").toLowerCase().includes((searchText || "").toLowerCase());

  const displayedOptions = useMemo(
    () =>
      statesByCountry.filter((option: any) => containsText(option, searchQuery)),
    [searchQuery, statesByCountry]
  );

  return (
    <Box>
      <FormControl fullWidth>
        <Select
          value={selectedValue}
          onChange={(e) =>
            onSelection({ name: e?.target?.value, value: e?.target?.value })
          }
          onClose={() => setSearchQuery("")}
          renderValue={(selected: any) => {
            if (!selected) {
              return (
                <Typography
                  sx={{ textTransform: "capitalize", color: "#3B3F76",fontSize:"14px" }}
                >
                  State
                </Typography>
              );
            }
            return selected;
          }}
          size="small"
          fullWidth
          displayEmpty
          sx={{
            "&.MuiInputBase-root": {
              borderRadius: "10px !important",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: 0,
            },
            background: "#F0F1F9",
            borderRadius: "10px",
          }}
          defaultValue=""
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                maxWidth: 300,
                "&.MuiPaper-root": {
                  boxShadow: 3,
                  borderRadius: "15px !important",
                },
              },
            },
            autoFocus: false,
          }}
          IconComponent={ExpandMoreIcon}
        >
      
          {countrieslist && (
            <ListSubheader>
              <TextField
                size="small"
                // autoFocus
                placeholder="Type to search..."
                fullWidth
                autoFocus={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
          )}

          {countrieslist ? (
            displayedOptions.length > 0 ? (
              displayedOptions.map((option: any, i: number) => (
                <MenuItem
                  key={i}
                  value={option}
                  sx={{
                    "& .MuiTypography-root": {
                      fontSize: "14px !important",
                    },
                    "& .MuiSvgIcon-root ": {
                      fontSize: "1rem",
                    },
                    whiteSpace: "normal",
                  }}
                >
                 <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Typography fontWeight="300"> {option}</Typography>
                {props.appliedFilter?.data.find(
                  (data: any) => data.value === option
                ) ? (
                  <CheckCircleIcon fontSize="small" />
                ) : (
                  ""
                )}
              </Box>
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No options available</MenuItem>
            )
          ) : (
            <MenuItem disabled>Please select country</MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );
  
}
  


export const CityFilter = (
  props:
    | {
        data: FilterInfo;
        onSelection: any;
        normalizeType: any;
        appliedFilter: FilterSelected;
        appliedFilters: FilterSelected[] | undefined;
      }
    | any
) => {
  const navigate = useNavigate();
  const destination: any = destinationList;
  const stateList = (country: string) =>
    Object.keys(destination[country] || {});
  const countrieslist = props?.appliedFilters?.find(
    (item: FilterSelected) => item.type === "country"
  );
  const statelist = props.appliedFilters?.find(
    (item: FilterSelected) => item.type === "state"
  );
  const cityList = (country: any, state: any) => destination[country][state];
  const citiesForSelectedCountry = countrieslist?.data
    ? countrieslist?.data.flatMap((country: any) =>
        statelist?.data
          ? statelist?.data.flatMap((state: any) =>
              cityList(country.value, state.value)
            )
          : stateList(country.value).flatMap((state: any) =>
              cityList(country.value, state)
            )
      )
    : [];
  const onSelection = (val: filterList) => {
    const filterData = FilterHandler({
      data: val,
      filterInfo: props.data,
      filter: props.appliedFilter,
    });
    const encodedUrl = location.search.slice(1); 
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = ""; 
    }
  
    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    const allFilters = FiltersHandler(
      filterData,
      FilterUrl ? JSON.parse(FilterUrl) : []
    );
    navigate(getExploreUrl("filterData", allFilters));
  };

  const containsText = (text: string, searchText: string) =>
    text?.toLowerCase()?.indexOf(searchText?.toLowerCase()) > -1;

  const [searchQuery, setSearchQuery] = useState("");
  const displayedOptions = useMemo(
    () =>
      citiesForSelectedCountry.filter((option: any) =>
        containsText(option, searchQuery)
      ),
    [searchQuery, countrieslist]
  );

  return (
    <Box sx={{}}>
      <FormControl fullWidth>
        <Select
          value=""
          onChange={(e) =>
            onSelection({ name: e.target.value, value: e.target.value })
          }
          onClose={() => setSearchQuery("")}
          renderValue={(selected: any) => {
            if (!selected) {
              return (
                <Typography
                  sx={{ textTransform: "capitalize", color: "#3B3F76",fontSize:"14px" }}
                >
                  City
                </Typography>
              );
            }
            return selected;
          }}
          size="small"
          fullWidth
          displayEmpty
          sx={{
            "&.MuiInputBase-root": {
              borderRadius: "10px !important",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: 0,
            },
            background: "#F0F1F9",
            borderRadius: "10px",
          }}
          defaultValue=""
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                maxWidth: 300,
                "&.MuiPaper-root": {
                  boxShadow: 3,
                  borderRadius: "15px !important",
                },
              },
            },
            autoFocus: false,
          }}
          IconComponent={ExpandMoreIcon}
        >
          {countrieslist && 
          <ListSubheader sx={{}}>
            <TextField
              size="small"
              // autoFocus
              placeholder="Type to search..."
              fullWidth
              autoFocus={true}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader> }
          {countrieslist ? (
          displayedOptions?.length > 0 ?  displayedOptions?.map((option: any, i: number) => (
            <MenuItem
              key={i}
              value={option}
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "14px !important",
                },
                "& .MuiSvgIcon-root ": {
                  fontSize: "1rem",
                },
                whiteSpace: "normal",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Typography fontWeight="300"> {option}</Typography>
                {props.appliedFilter?.data.find(
                  (data: any) => data.value === option
                ) ? (
                  <CheckCircleIcon fontSize="small" />
                ) : (
                  ""
                )}
              </Box>
            </MenuItem>
          )): (
            <MenuItem disabled>No options available</MenuItem>
          )
        ) : (
          <MenuItem disabled>Please select country</MenuItem>
        )}
        </Select>
      </FormControl>
    </Box>
  );
};
export const Budget = (
  props:
    | {
        data: FilterInfo;
        onSelection: any;
        normalizeType: any;
        appliedFilter: FilterSelected;
        appliedFilters: FilterSelected[] | undefined;
      }
    | any
) => {
  const [minBudget, setMinBudget] = useState<number>(0);
  const [maxBudget, setMaxBudget] = useState<number>(5000000);
  const navigate = useNavigate();

  const handleSliderChange = (_event: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      setMinBudget(newValue[0]);
      setMaxBudget(newValue[1]);
    }
  };
  const onSelection = (val: any) => {
    const filterData = {type:"budget",data:[{name:`${minBudget}`,value:minBudget},{name:`${maxBudget}`,value:maxBudget}]}
    const encodedUrl = location.search.slice(1); 
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = ""; 
    }
  
    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    const allFilters = FiltersHandler(
      filterData,
      FilterUrl ? JSON.parse(FilterUrl) : []
    );
    navigate(getExploreUrl("filterData", allFilters));
  };
  const handleSliderChangeCommitted = (
    event: React.ChangeEvent<{}>,
    value: number | number[]
  ) => {
    if (Array.isArray(value)) {
      onSelection(value);
    }
  };
  return (
    <>
      <Typography color="#3B3F76" fontSize="14px">Budget</Typography>
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <TextField
          name="minBudget"
          label="Min"
          type="number"
          disabled
          size="small"
          value={minBudget}
          onChange={(e: any) => setMinBudget(e.target.value)}
        />
        <TextField
          name="maxBudget"
          label="Max"
          disabled
          type="number"
          size="small"
          value={maxBudget}
          onChange={(e: any) => setMaxBudget(e.target.value)}
        />
      </Stack>
      <Slider
        getAriaLabel={() => "budget range"}
        min={1}
        max={5000000}
        value={[minBudget, maxBudget]}
        onChange={handleSliderChange}
        onChangeCommitted={(event, value) =>
          handleSliderChangeCommitted(event as React.ChangeEvent<{}>, value)
        }
        step={1}
        sx={{
          mt: 2,
          mx: 2,
          width: { xs: "80%", md: "70%" },
          color: "#979a9d",
          height: "2px",
          "& .MuiSlider-thumb ":{
            backgroundColor:"#b5b5f1"
          },"& .MuiSlider-track":{
            backgroundColor:"#FFDAA1"
          }
        }}
      />
    </>
  );
};
export const AcademicFilter = (
  props:
    | {
        data: FilterInfo;
        onSelection: any;
        normalizeType: any;
        appliedFilter: FilterSelected;
        appliedFilters: FilterSelected[] | undefined;
      }
    | any
) => {
  const navigate = useNavigate();

  const onSelection = (val: filterList | any) => {
    const filterData = FilterHandler({
      data: val,
      filterInfo: props.data,
      filter: props.appliedFilter,
    });
    const encodedUrl = location.search.slice(1); 
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = ""; 
    }
  
    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    const allFilters = FiltersHandler(
      filterData,
      FilterUrl ? JSON.parse(FilterUrl) : []
    );
    navigate(getExploreUrl("filterData", allFilters));
  };

  const displayedOptions = [
    {
      name: "GRE",
      value: {
        required: true,
        name: "GRE",
      },
    },
    {
      name: "GMAT",
      value: {
        required: true,
        name: "GMAT",
      },
    },
    {
      name: "ACT",
      value: {
        required: true,
        name: "ACT",
      },
    },
    {
      name: "SAT",
      value: {
        required: true,
        name: "SAT",
      },
    },
    {
      name: "GRE",
      value: {
        required: false,
        name: "GRE",
      },
    },
    {
      name: "GMAT",
      value: {
        required: false,
        name: "GMAT",
      },
    },
    {
      name: "ACT",
      value: {
        required: false,
        name: "ACT",
      },
    },
    {
      name: "SAT",
      value: {
        required: false,
        name: "SAT",
      },
    },
  ];
  const requiredOptions = displayedOptions.filter(
    (option) => option.value.required
  );
  const notRequiredOptions = displayedOptions.filter(
    (option) => !option.value.required
  );

  return (
    <Box sx={{}}>
      <FormControl fullWidth>
        <Select
          value=""
          onChange={(e) => onSelection(e.target.value)}
          renderValue={(selected: any) => {
            if (!selected) {
              return (
                <Typography
                  sx={{ textTransform: "capitalize", color: "#3B3F76",fontSize:"14px" }}
                >
                  Aptitude Test
                </Typography>
              );
            }
            return selected;
          }}
          size="small"
          fullWidth
          displayEmpty
          sx={{
            "&.MuiInputBase-root": {
              borderRadius: "10px !important",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: 0,
            },
            background: "#F0F1F9",
            borderRadius: "10px",
          }}
          defaultValue=""
          MenuProps={{
            PaperProps: {
              sx: { maxHeight: 300 },
            },
            autoFocus: false,
          }}
          IconComponent={ExpandMoreIcon}
        >
          <ListSubheader>Required</ListSubheader>

          {requiredOptions.length > 0 &&
            requiredOptions.map((option: any, i: number) => (
              <MenuItem
                key={i}
                value={option}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "14px !important",
                  },
                  "& .MuiSvgIcon-root ": {
                    fontSize: "1rem",
                  },
                  whiteSpace: "normal",
                  backgroundColor: props.appliedFilter?.data.find(
                    (data: any) =>
                      data.name === option.value.name &&
                      data.value.required === option.value.required
                  )
                    ? "grey"
                    : "transparent",
                }}
              >
                {option.name}
              </MenuItem>
            ))}
          <ListSubheader>Not Required</ListSubheader>

          {notRequiredOptions.length > 0 &&
            notRequiredOptions.map((option: any, i: number) => (
              <MenuItem
                key={i}
                value={option}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "14px !important",
                  },
                  "& .MuiSvgIcon-root ": {
                    fontSize: "1rem",
                  },
                  whiteSpace: "normal",
                  backgroundColor: props.appliedFilter?.data.find(
                    (data: any) =>
                      data.name === option.value.name &&
                      data.value.required === option.value.required
                  )
                    ? "grey"
                    : "transparent",
                }}
              >
                {option.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};
export const LanguageFilter = (
  props:
    | {
        data: FilterInfo;
        onSelection: any;
        normalizeType: any;
        appliedFilter: FilterSelected;
        appliedFilters: FilterSelected[] | undefined;
      }
    | any
) => {
  const navigate = useNavigate();

  const onSelection = (val: filterList | any) => {
    const filterData = FilterHandler({
      data: val,
      filterInfo: props.data,
      filter: props.appliedFilter,
    });
    const encodedUrl = location.search.slice(1); 
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = ""; 
    }
  
    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    const allFilters = FiltersHandler(
      filterData,
      FilterUrl ? JSON.parse(FilterUrl) : []
    );
    navigate(getExploreUrl("filterData", allFilters));
  };

  const displayedOptions = [
    {
      name: "TOEFL",
      value: {
        required: true,
        name: "TOEFL",
      },
    },
    {
      name: "IELTS",
      value: {
        required: true,
        name: "IELTS",
      },
    },
    {
      name: "PTE",
      value: {
        required: true,
        name: "PTE",
      },
    },
    {
      name: "DET",
      value: {
        required: true,
        name: "DET",
      },
    },
    {
      name: "TOEFL",
      value: {
        required: false,
        name: "TOEFL",
      },
    },
    {
      name: "IELTS",
      value: {
        required: false,
        name: "IELTS",
      },
    },
    {
      name: "PTE",
      value: {
        required: false,
        name: "PTE",
      },
    },
    {
      name: "DET",
      value: {
        required: false,
        name: "DET",
      },
    },
  ];
  const requiredOptions = displayedOptions.filter(
    (option) => option.value.required
  );
  const notRequiredOptions = displayedOptions.filter(
    (option) => !option.value.required
  );

  return (
    <Box sx={{}}>
      <FormControl fullWidth>
        <Select
          value=""
          onChange={(e) => onSelection(e.target.value)}
          renderValue={(selected: any) => {
            if (!selected) {
              return (
                <Typography
                  sx={{ textTransform: "capitalize", color: "#3B3F76",fontSize:"14px" }}
                >
                  Language Test
                </Typography>
              );
            }
            return selected;
          }}
          size="small"
          fullWidth
          displayEmpty
          sx={{
            "&.MuiInputBase-root": {
              borderRadius: "10px !important",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: 0,
            },
            background: "#F0F1F9",
            borderRadius: "10px",
          }}
          defaultValue=""
          MenuProps={{
            PaperProps: {
              sx: { maxHeight: 300 },
            },
            autoFocus: false,
          }}
          IconComponent={ExpandMoreIcon}
        >
          <ListSubheader>Required</ListSubheader>

          {requiredOptions.length > 0 &&
            requiredOptions.map((option: any, i: number) => (
              <MenuItem
                key={i}
                value={option}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "14px !important",
                  },
                  "& .MuiSvgIcon-root ": {
                    fontSize: "1rem",
                  },
                  whiteSpace: "normal",
                  backgroundColor: props.appliedFilter?.data.find(
                    (data: any) =>
                      data.name === option.value.name &&
                      data.value.required === option.value.required
                  )
                    ? "grey"
                    : "transparent",
                }}
              >
                {option.name}
              </MenuItem>
            ))}
          <ListSubheader>Not Required</ListSubheader>

          {notRequiredOptions.length > 0 &&
            notRequiredOptions.map((option: any, i: number) => (
              <MenuItem
                key={i}
                value={option}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "14px !important",
                  },
                  "& .MuiSvgIcon-root ": {
                    fontSize: "1rem",
                  },
                  whiteSpace: "normal",
                  backgroundColor: props.appliedFilter?.data.find(
                    (data: any) =>
                      data.name === option.value.name &&
                      data.value.required === option.value.required
                  )
                    ? "grey"
                    : "transparent",
                }}
              >
                {option.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};
